// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CNoteBase_abstract } from './../abstract/SagaSchema/CNoteBase_abstract';
export class CNoteBase extends CNoteBase_abstract {
  get icon() {
    return 'document-text';
  }
}
